export default () =>
  ({
    wrap: {
      marginBlockStart: '8px',
      display: 'block',
    },
  }) as const
